module.exports = __webpack_public_path__ + "static/img/text_bg.3f60a833.png";